import { gql } from 'apollo-angular';
export var update_description = gql`
  mutation updateDescription($id: ID!, $description: String!) {
    updateDescription(id: $id, description: $description){
      id, description
    }
  }
`;

export var update_hard_debt = gql`
  mutation updateHardDebt($id: ID!, $leverage: Float) {
    updateHardDebt(id: $id, leverage: $leverage){
      id, leverage
    }
  }
`;

export var update_units = gql`
  mutation updatePropertyUnits($id: ID!,
  $buildings: Int,
  $total_units: Int,
  $total_lihtc_units: Int,
  $total_market_rate_units: Int,
  $total_common_units: Int,
  $total_family_units: Int,
  $total_senior_units: Int
  $total_rental_assistance_units: Int
  ) {
    updatePropertyUnits(id: $id,
        buildings: $buildings,
      total_units: $total_units, total_lihtc_units: $total_lihtc_units,
      total_market_rate_units: $total_market_rate_units, total_common_units: $total_common_units, total_family_units: $total_family_units,
        total_senior_units: $total_senior_units, total_rental_assistance_units: $total_rental_assistance_units
    ){
      id, buildings, total_units, total_lihtc_units,
      total_market_rate_units, total_rental_assistance_units,
      total_common_units, total_family_units, total_senior_units
    }
  }
`;
